import { Component, h, Prop } from '@stencil/core';

interface DrawerElement extends HTMLElement {
  isOpen: boolean;
}

@Component({
  tag: 'qumra-drawer-button',
  styleUrl: 'qumra-drawer-button.css',
  shadow: true,
})
export class QumraDrawerButton {
  @Prop() drawerId: string;

  render() {
    return (
      <div
        onClick={() => {
          const drawer = document.querySelector(`#${this.drawerId}`) as DrawerElement;
          if (drawer) {
            drawer.isOpen = !drawer.isOpen;
          }
        }}
        class="w-max h-max"
      >
       <slot></slot>
      </div>
    );
  }
}
